import { render, staticRenderFns } from "./CrownMoneyWithdrawalTable.vue?vue&type=template&id=a1aaa678"
import script from "./CrownMoneyWithdrawalTable.vue?vue&type=script&lang=js"
export * from "./CrownMoneyWithdrawalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../website/node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QSkeleton,QBtn,QBtnDropdown,QCheckbox,QSelect,QSpinnerDots,QInput,QIcon,QTr,QTh,QTd,QChip,QPopupEdit,QTooltip,QBadge});
